import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import SidebarHello from "../Components/HelloGameLayoutComponent/SidebarHello";
import Header from "../Components/HelloGameLayoutComponent/HederHello";
import styled from "styled-components";
import {
  Event,
  decode,
  encode,
  wait,
  isMobile,
  sendNotfication,
  getUID,
} from "../../Helper";
import WalletAlert from "../../App/Components/User/Wallet/Alert";
import C from "../../Constant";
import storage from "../../Storage";
import UserHeader from "./Parts/Header/Header-User";
import GuestHeader from "./Parts/Header/Header-Guest";
import socket from "../../Socket";
import MobileMenu from "./Parts/Menu/MobileMenu";
import HelloFooter from "../Components/HelloGameLayoutComponent/HelloFooter";
import SportsFooter from "../Components/HelloGameLayoutComponent/SportsFooter";
import SkylaSidebar from "../Components/SkylaSiebar";
import { SidebarProvider, useSidebar } from "../../Context/SidebarContext";
import LoginSuccessModal from "../Components/LoginSuccess";
import BottomNavigation from "../Components/SkylaBottomTab";

// Always initialize coin to INR if not set
if (!storage.getKey("coin") || storage.getKey("coin") !== "INR") {
  storage.setKey("coin", "INR");
}
const SIDEBAR_WIDTH = 245;
const HEADER_HEIGHT = 60;

const AppContainer = styled.div`
  display: flex;
  background: #232626;

  color: white;
  font-family: Arial, sans-serif;
  // z-index:1000;
`;

const MainArea = styled.div`
  flex: 1;
  padding-top: 60px;
  min-height: 100vh;
  width: ${(props) =>
    props.isSportsRoute ? "100vw" : `calc(100vw - ${SIDEBAR_WIDTH}px)`};
  overflow-x: hidden;
  z-index: -1 important;
  margin: ${(props) => {
    if (props.isSportsRoute) {
      return "0px";
    }
    return props.isSmallScreen
      ? "0px"
      : props.isCollapsed
        ? "0px 120px 0px 170px"
        : "0px 20px 0px 250px";
  }};

  // margin-left: ${(props) =>
    props.isSmallScreen ? "0px" : props.isCollapsed ? "0px" : "239px"};
`;

const ContentContainer = styled.div`
  padding: 0px 24px;
  margin-top: 20px;
  min-height: calc(100vh - ${HEADER_HEIGHT}px);

  @media (max-width: 768px) {
    padding: 4px 10px;
    margin-top: 5px;
  }
`;

const HeaderMainConatiner = styled.div`
  position: fixed;
  top: 0;
  // left: ${(props) =>
    props.isSmallScreen ? "0px" : props.isCollapsed ? "80px" : "239px"};
  left: 0;
  right: 0;
  z-index: 666;
  width: 100% !important;
`;

const Index = ({ get_wallet, content }) => {
  const [auth, setAuth] = useState(false);
  const { isCollapsed, setIsCollapsed } = useSidebar();
  const location = useLocation();

  const uid = getUID;
  const [isCollapsedMobile, setIsCollapsedMobile] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  // Check if current route is sports-related
  const isSportsRoute = () => {
    const path = location.pathname;
    return path.startsWith("/sports/") || path.startsWith("/match/");
  };
  const [header, setHeader] = useState(
    storage.getKey('logged') === 'true' && storage.getKey('token')
      ? <UserHeader isCollapsedMobile={isCollapsedMobile} setIsCollapsedMobile={setIsCollapsedMobile} />
      : <GuestHeader />
  );
  const getUserInfo = (data) => {
    // handle user info
  };

  useEffect(() => {
    if (uid) {
      socket.on(C.USER_INFO, (data) => getUserInfo(decode(data)));
      socket.emit(
        C.USER_INFO,
        encode({
          id: getUID,
          coin: storage.getKey("coin") ? storage.getKey("coin") : "",
          rate: null,
          game: "all",
          first: true,
        }),
      );
    }
  }, [uid]);

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    const handleOnline = (status) => onlineUser(decode(status));
    socket.on(C.ONLINE, handleOnline);

    Event.on("showAuthModal", () => {
      sendNotfication(
        "Please Login or Register!",
        "success",
        "bottom-left",
        true,
      );
    });

    const sessionCookie = Cookies.get("session");
    if (sessionCookie) {
      socket.emit(
        C.ONLINE,
        encode({
          jwt_token: storage.getKey("jwt_token"),
          user_token: storage.getKey("user_token"),
          security_key: storage.getKey("security_key"),
          secret_user: storage.getKey("secret_user"),
          secret_realtime: storage.getKey("secret_realtime"),
          client_system: storage.getKey("client_system"),
          token_key: storage.getKey("token_key"),
          secret_token: storage.getKey("secret_token"),
        }),
      );
    }

    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      socket.off(C.ONLINE, handleOnline);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const activeAuth = (status) => {
    setAuth(status);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
    // Also handle document body and documentElement
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  // Effect to handle scroll reset on mount and route changes
  useEffect(() => {
    scrollToTop();

    // Handle scroll reset when the content prop changes
    const handleRouteChange = () => {
      scrollToTop();
    };

    // Add event listener for route changes if using a router
    if (window.history) {
      window.addEventListener("popstate", handleRouteChange);
    }

    return () => {
      if (window.history) {
        window.removeEventListener("popstate", handleRouteChange);
      }
    };
  }, [content]);

  const onlineUser = (data) => {
    if (data.status === true) {
      storage.setKey("logged", true);
      Cookies.set("uid", data.id, { expires: 14 });
      Cookies.set("auth", true, { expires: 14 });
      storage.setKey("name", data.name);
      storage.setKey("email", data.email);
      storage.setKey("credit", data.credit);
      storage.setKey("avatar", data.avatar);
      storage.setKey("friends", data.friends);
      storage.setKey("room", data.room);
      setHeader(
        <UserHeader
          isCollapsedMobile={isCollapsedMobile}
          setIsCollapsedMobile={setIsCollapsedMobile}
        />,
      );
    } else {
      // Only logout if user was previously considered logged in
      // This prevents false logout from network hiccups
      if (storage.getKey("logged") === "true") {
        storage.removeKey("logged");
        storage.removeKey("token");
        storage.removeKey("jwt_token");
        storage.removeKey("user_token");
        storage.removeKey("security_key");
        storage.removeKey("name");
        storage.removeKey("email");
        storage.removeKey("credit");
        Cookies.remove("uid");
        Cookies.remove("auth");
        Cookies.remove("session");
        setHeader(<GuestHeader />);
      }
    }
  };

  let wallet;
  try {
    wallet = get_wallet.show;
  } catch (e) {}

  return (
    <>
      <AppContainer>
        <MainArea
          isSmallScreen={isSmallScreen}
          isCollapsed={isCollapsed}
          isSportsRoute={isSportsRoute()}
        >
          <HeaderMainConatiner
            isSmallScreen={isSmallScreen}
            isCollapsed={isCollapsed}
          >
            {header}
          </HeaderMainConatiner>
          <ContentContainer
            isSmallScreen={isSmallScreen}
            isCollapsed={isCollapsed}
          >
            {content}
          </ContentContainer>
        </MainArea>
      </AppContainer>
      {isSportsRoute() ? <SportsFooter /> : <HelloFooter />}
      {/* <LoginSuccessModal/> */}
      <BottomNavigation />
    </>
  );
};

AppContainer.propTypes = {
  get_wallet: PropTypes.string,
};

const mapStateToProps = (state) => ({
  get_wallet: state.items.get_wallet,
});

export default connect(mapStateToProps)(Index);
